import getDistanceMap from 'utils/getDistanceMap';

const getNearestCountry = (latitude, longitude) => {
  if (latitude && longitude) {
    const canLat = 56.1304,
      canLong = -106.3468;

    const usaLat = 37.0902,
      usaLong = -95.7129;

    const canDistance = getDistanceMap(latitude, longitude, canLat, canLong);
    const usaDistance = getDistanceMap(latitude, longitude, usaLat, usaLong);

    return canDistance < usaDistance ? 'CAN' : 'USA';
  }

  return '';
};

export default getNearestCountry;
